import moment from 'moment'
import { CreatePolicyholderEntityClientRequest } from '../../@types/CreatePolicyholderEntity'
import { truncateAddress } from '../../utils/streetNameFormatted'
import { FormAddressValuesProps } from './components/AddressForm'
import { FormContactValuesProps } from './components/ContactForm'
import { FormIdentificationValuesProps } from './components/IdentificationForm'

interface Props {
  formIdentificationValues: FormIdentificationValuesProps
  formAddressValues: FormAddressValuesProps
  formContactValues: FormContactValuesProps
}

export const handleCreatePolicyPayload = ({
  formAddressValues,
  formContactValues,
  formIdentificationValues,
}: Props) => {
  const [zipCode, zipCodeExtension] = (
    formAddressValues?.entityZipCode || ''
  )?.split('-')

  const addressTruncated = truncateAddress(
    formAddressValues,
    'entityComplement',
  )

  const payloadIndividual: CreatePolicyholderEntityClientRequest = {
    policyHolder: {
      vatNumber: formIdentificationValues?.vatNumber || '',
      entityType: 'Individual', //TODO: check where this data will come from, Context?
      name: formIdentificationValues?.name || '',
      birthdate: moment(
        formIdentificationValues?.birthdate,
        'DD-MM-YYYY',
      ).format('YYYY-MM-DDTHH:mm:ss'),
      individualEmployee: formIdentificationValues?.eni === '1',
      gender: formIdentificationValues?.gender || '',
      job: formIdentificationValues?.entityJob || '',
      jobDescription: formIdentificationValues?.entityJobDescription || '',
      nationalityCountry: {
        nationality: formIdentificationValues?.nationality || '',
        nationalityId: formIdentificationValues?.nationalityId || '',
        mainNationality: true, //TODO: Don`t have this info. Review
      },
      address: {
        postalCode: (zipCode || '').toString() || '0',
        postalCodeExtension: (zipCodeExtension || '').toString() || '0',
        addressTypology: '1', //TODO: check where this data will come from
        houseNumber: addressTruncated.entityNumberPolice || '',
        locality: addressTruncated.entityLocalization || '',
        streetType: addressTruncated.entityTypeArteria || '',
        streetAddress: addressTruncated.entityNameArteria || '',
        address: addressTruncated.entityNameArteria || '',
        countryCode: 'PRT', //TODO: Check if this information will come from
        doorNumber: addressTruncated.entityNumberDoor || '',
        floor: addressTruncated.entityFloor || '',
        fraction: '', //TODO: check where this data will come from
        additionalInformation: addressTruncated.entityComplement || '',
      },
      contactDetails: {
        phoneContact: {
          phoneNumber: formContactValues?.contactPhoneNumber || '',
          phoneContactTypeCode: formContactValues?.contactPhone || '',
        },
        emailContact: {
          email: formContactValues?.email || '',
        },
      },
      mainCae: '', //TODO: check where this data will come from
    },
  }

  return payloadIndividual
}
